import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const TOKEN_LENGTH = 64;

export const activationTokenGuard: CanActivateFn = (route) => {
  if (route.queryParamMap.get('token')?.trim()?.length === TOKEN_LENGTH) {
    return true;
  }

  return inject(Router).createUrlTree(['/auth/login']);
};
